import React from "react";
import {Row, Col} from "antd";
import styles from './index.module.scss';
import "react-responsive-carousel/lib/styles/carousel.min.css";

import miurLogo from '../../../assets/images/partners/00_LOGO_MIUR.png'
import partnersImg1 from '../../../assets/images/partners/01-Scuola-digitale-Partnership-MyEdu.png'
import partnersImg2 from '../../../assets/images/partners/02-Rai-Partnership-MyEdu.png'
import partnersImg3 from '../../../assets/images/partners/03-Fondazione-per-la-Scuola-Partnership-MyEdu.png'
import partnersImg4 from '../../../assets/images/partners/04-Riconnessioni-Partnership-MyEdu.png'
import partnersImg5 from '../../../assets/images/partners/05-Humanitas-university-Partnership-MyEdu.png'
import partnersImg6 from '../../../assets/images/partners/06-Festival-della-comunicazione-Partnership-MyEdu.png'
import partnersImg7 from '../../../assets/images/partners/07-Parco-Collodi-Pinocchio-Partnership-MyEdu.png'
import partnersImg8 from '../../../assets/images/partners/08-Muba-Partnership-MyEdu.png'
import partnersImg9 from '../../../assets/images/partners/09-Acquario-di-Genova-Partnership-MyEdu.png'
import partnersImg10 from '../../../assets/images/partners/10-BVA-Doxa-Partnership-MyEdu.png'
import partnersImg11 from '../../../assets/images/partners/11-La-Scuola-in-ospedale-Partnership-MyEdu.png'
import partnersImg12 from '../../../assets/images/partners/12-Mamma-pret-a-porter-Partnership-MyEdu.jpg'
import partnersImg13 from '../../../assets/images/partners/13-Mama-Boom-Partnership-MyEdu.jpg'
import partnersImg14 from '../../../assets/images/partners/14-Moms-About-Town-Partnership-MyEdu.jpg'
import partnersImg15 from '../../../assets/images/partners/15-Mum-Advisor-Partnership-MyEdu.jpg'
import partnersImg16 from '../../../assets/images/partners/16-TendiTrendy-Partnership-MyEdu.jpg'
import partnersImg17 from '../../../assets/images/partners/17-La-scuola-a-casa-Partnership-MyEdu.jpg'
import partnersImg18 from '../../../assets/images/partners/18-Monterossi-4-you-Partnership-MyEdu.jpg'
// import partnersImg19 from '../../../assets/images/partners/19-REKORDATA-Partnership-MyEdu.jpg'
import partnersImg20 from '../../../assets/images/partners/20-Geomag-Education-Partnership-MyEdu.jpg'
import partnersImg21 from '../../../assets/images/partners/21-Carta-del-Docente-Partnership-MyEdu.jpg'
import partnersImg22 from '../../../assets/images/partners/22-CDO-Opere-Educative-Partnership-MyEdu.jpg'

const partnersList = [
    {
      img: partnersImg1,
      title: "Scuola Digitale",
      href: 'https://www.istruzione.it/scuola_digitale/prog-atelier.shtml',
    },
    {
      img: partnersImg2,
      title: "RAI",
      href: 'https://www.rai.it/ufficiostampa/assets/template/us-articolo.html?ssiPath=/articoli/2020/07/La-banda-dei-Fuoriclasse-il-Ripassone-d37e8422-c716-4cf6-89ea-12957f5bb034-ssi.html',
    },
    {
      img: partnersImg3,
      title: "Fondazione per la Scuola",
      href: 'https://www.fondazionescuola.it/',
    },
    {
      img: partnersImg4,
      title: "Riconnessioni",
      href: 'https://www.riconnessioni.it/',
    },
    {
      img: partnersImg5,
      title: "Humanitas University",
      href: 'https://www.hunimed.eu/it/',
    },
    {
      img: partnersImg6,
      title: "Festival della Comunicazione",
      href: 'http://www.festivalcomunicazione.it/',
    },
    {
      img: partnersImg7,
      title: "Parco Collodi Pinocchio",
      href: 'https://www.pinocchio.it/',
    },
    {
      img: partnersImg8,
      title: "MUBA",
      href: 'https://muba.myedu.it/',
    },
    {
      img: partnersImg9,
      title: "Acquario di Genova",
      href: 'https://www.acquariodigenova.it/',
    },
    {
      img: partnersImg10,
      title: "BVA Doxa",
      href: 'https://www.bva-doxa.com/',
    },
    {
      img: partnersImg11,
      title: "La Scuola in Ospedale",
      href: 'https://scuolainospedale.miur.gov.it/',
    },
    {
      img: partnersImg12,
      title: "Mamma pret a porter",
      href: 'https://www.mammapretaporter.it/educazione/educazione-naturale/scuole-chiuse-per-il-coronavirus-ci-sono-le-lezioni-online-e-i-libri',
    },
    {
      img: partnersImg13,
      title: "Mama Boom",
      href: 'https://mamabooom.com/2020/04/23/myedu-family-un-valido-aiuto-per-i-nostri-bambini/',
    },
    {
      img: partnersImg14,
      title: "Moms About Town",
      href: 'https://www.momsabouttown.it/myedu-la-didattica-a-distanza-non-e-mai-stata-cosi-divertente/',
    },
    {
      img: partnersImg15,
      title: "Mum Advisor",
      href: 'https://mumadvisor.com/imparare-divertendosi-in-compagnia-di-myedu/',
    },
    {
      img: partnersImg16,
      title: "Trendi Trendy",
      href: 'https://tenditrendy.com/didattica-digitale-io-ho-scelto-myedu/',
    },
    {
      img: partnersImg17,
      title: "La Scuola a Casa",
      href: 'https://lascuolaacasa.com/',
    },
    {
      img: partnersImg18,
      title: "Montessori $ You",
      href: 'https://www.montessori4you.it/',
    },
    // {
    //   img: partnersImg19,
    //   title: "Rekordata",
    //   href: 'https://www.rekordata.it/',
    // },
    {
      img: partnersImg20,
      title: "Geomag Education",
      href: 'https://education.geomagworld.com/it/',
    },
    {
      img: partnersImg21,
      title: "Carta del Docente",
      href: 'https://www.cartadeldocente.istruzione.it/#/',
    },
    {
      img: partnersImg22,
      title: "CDO Opere Educative",
      href: 'https://www.foe.it/',
    },
];

const Partners = () => {
  return (
    <Row
      gutter={16}
      className={styles.partnersMainRow}
    >
      <Col
        className={styles.partnersTitleCol}
        xs={24}
      >
        <h2>Protocollo d'intesa con il ministero dell'istruzione</h2>

        <p>
          Nuovo protocollo d’intesa stipulato con il Ministero dell’Istruzione per la realizzazione di azioni
          a supporto dell’innovazione digitale nella Scuola italiana.
        </p>

        <a
          href="https://www.miur.gov.it/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className={styles.miurLogo}
            src={miurLogo}
            alt="MIUR"
          />
        </a>
      </Col>
      {
        partnersList.map((partner, index) => (
            <Col
                key={partner.href}
                className={styles.partnerLogoCol}
                xs={12}
                sm={6}
                lg={4}
            >
                <a
                    href={partner.href}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src={partner.img}
                        alt={partner.title}
                        className={styles.partnerLogo}
                    />
                </a>
            </Col>
        ))
      }
    </Row>
  )
}

export default Partners;

